const MS_PER_SECOND = 1000;
const MS_PER_MINUTE = 60 * MS_PER_SECOND;
const MS_PER_HOUR = 60 * MS_PER_MINUTE;
export const MS_PER_DAY = 24 * MS_PER_HOUR;

export interface TTimeUnits {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
}

export function parseMsToTimeUnits(ms: number): TTimeUnits {
  let remaining = ms;

  const days = Math.floor(remaining / MS_PER_DAY);
  remaining %= MS_PER_DAY;

  const hours = Math.floor(remaining / MS_PER_HOUR);
  remaining %= MS_PER_HOUR;

  const minutes = Math.floor(remaining / MS_PER_MINUTE);
  remaining %= MS_PER_MINUTE;

  const seconds = Math.floor(remaining / MS_PER_SECOND);

  return { days, hours, minutes, seconds };
}

export function timeUnitsToMs(units: Partial<TTimeUnits>): number {
  return (
    (units.days ?? 0) * MS_PER_DAY +
    (units.hours ?? 0) * MS_PER_HOUR +
    (units.minutes ?? 0) * MS_PER_MINUTE +
    (units.seconds ?? 0) * MS_PER_SECOND
  );
}
